import React, { Component } from 'react';
import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import { firebaseRoot } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import Lazy from 'lazy.js';

const Roles = React.createClass({

    mixins: [ReactFireMixin],

    getInitialState () {
        return {text: ''}
    },

    componentWillMount() {
        this.adminRolesRef = firebaseRoot.child('roles/admins');
        this.bindAsArray(this.adminRolesRef, 'adminroles');
        this.bindAsTransform(firebaseRoot.child('users'),
            'usersByKey',
            dataSnapshot => Lazy(dataSnapshot).dataSnapshot().indexBy(e => e.key()).toObject());
        this.bindAsTransform(firebaseRoot.child('users'),
            'usersByEmail',
            dataSnapshot => Lazy(dataSnapshot).dataSnapshot().indexBy(e => e.child('email').val()).toObject());
    },

    firebaseDidCancel(error) {
        console.log(error);
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }
        return (
            <div className="roles">
                <div className="input-group">
                    <input
                        value={this.state.text}
                        onChange={this.handleInputChange}
                        type="text"
                        className="form-control"
                        placeholder="enter the email here"
                    />
                      <span className="input-group-btn">
                        <TouchButton
                            onClick={this.addNew}
                            className="btn btn-default"
                            type="button">
                            Add to admin
                        </TouchButton>
                      </span>
                </div>

                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title">Admin emails list:</h3>
                    </div>

                    {this.state.adminroles.map(adminrole => {
                        const user = this.state.usersByKey[adminrole['.key']];
                        if (!user) {
                            return
                        }
                        return (
                            <div className="panel-body">
                                {user.child('email').val()}
                                <TouchButton className="pull-right"
                                             onClick={this.handleDelete.bind(this, adminrole['.key'])}>
                                    <Glyphicon glyph="trash"/>
                                </TouchButton>
                            </div>
                        );
                    })}

                </div>
            </div>
        )
    },

    handleInputChange: function (event) {
        this.setState({text: event.target.value});
    },

    onComplete: function (error) {
        if (error) {
            console.log('Synchronization failed');
        } else {
            console.log('Synchronization succeeded');
        }
    },

    addNew: function () {
        const user = this.state.usersByEmail[this.state.text];
        this.adminRolesRef.child(user.key()).set(true, this.onComplete);
        this.setState({text: ''});
    },

    handleDelete: function (id) {
        this.adminRolesRef.child(id).remove();
    }
});

export default Roles;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/Roles.js
 **/